function initializeCarousel() {
  const jbCarouselContainerElements = $(".jb-carousel-container");

  jbCarouselContainerElements.each(function() {
    const containerElement = $(this);
    const owlCarouselElement = $('.owl-carousel', containerElement);
    const itemsCountPerRow = owlCarouselElement.data('items-count') ?? 5;
    const sectionId = owlCarouselElement.data('section-id');

    if (!sectionId) {
      return;
    }

    const owlCarousel = $(".owl-carousel-" + sectionId);

    if (owlCarousel.length === 0) {
      return;
    }

    $('.jb-carousel-item-container', owlCarousel)
      .removeClass('d-none col d-flex justify-content-center')
      .removeAttr('style');

    owlCarousel.on('initialized.owl.carousel resized.owl.carousel', function (e) {
      const hideControls = e.item.count <= e.page.size;
      $('.jb-carousel-control-next', containerElement).toggleClass('d-none', hideControls);
      $('.jb-carousel-control-prev', containerElement).toggleClass('d-none', hideControls);
    });

    owlCarousel.owlCarousel({
      loop: true,
      margin: 15,
      nav: false,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        576: {
          items: itemsCountPerRow > 2 ? 2 : itemsCountPerRow
        },
        768: {
          items: itemsCountPerRow > 3 ? 3 : itemsCountPerRow
        },
        992: {
          items: itemsCountPerRow > 5 ? 5 : itemsCountPerRow
        },
        1200: {
          items: itemsCountPerRow,
        }
      }
    });

    if (itemsCountPerRow === 1) {
      $('.carousel-container', containerElement).css('max-width', '547px').css('width', '100%');
      $('.owl-stage-outer', owlCarousel).css('max-width', '547px').css('width', '100%');
    }

    const SPEED_OF_TRANSITION = 500;

    // Go to the next item
    $('.jb-carousel-control-next', containerElement).click(function() {
      owlCarousel.trigger('next.owl.carousel', [SPEED_OF_TRANSITION]);
    });

    // Go to the previous item
    $('.jb-carousel-control-prev', containerElement).click(function() {
      owlCarousel.trigger('prev.owl.carousel', [SPEED_OF_TRANSITION]);
    });
  });
}

function onInitOrRender() {
  initializeCarousel();
}

document.addEventListener('DOMContentLoaded', onInitOrRender);
document.addEventListener('jb.section.rendered', onInitOrRender);
document.addEventListener('section.initiated', onInitOrRender);
